import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';

export const NullLocationMessageContainer = styled(Flex, {
  marginTop: '20px',
  marginLeft: 'auto',
  marginRight: 'auto',
  textAlign: 'center',
  width: '90%',
});

export const StyleForHeader = {
  marginTop: '8px',
  'abyss-box-root': {
    '@screen < $md': {
      borderBottom: 'solid',
      borderColor: '$headerCardWrapperBorderColor',
    },
    borderBottom: 'solid 1px $gray3',
    padding: '24px',
    paddingLeft: '72px',
    height: 'auto',
  },
};

export const InfoButtonStyle = {
  'abyss-button-root': {
    width: 'auto',
    padding: '0px',
    minHeight: '16px',
    height: '16px',
    lineHeight: '16px',
  },
};
